import React, { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import Text from "../typography/text";
import DeleteIcon from "../../icons/delete-icon";
import { components } from "react-select";
import { colors } from "../../theme/colors";
// import loadOptions from "./asyncOptions";

const loadOptions = async (searchQuery, loadedOptions, { page }) => {
  const response = await fetch(
    `https://www.omdbapi.com/?apikey=6320ad34&s=${
      searchQuery ? searchQuery : "batman"
    }&page=${page}`
  );
  const responseJSON = await response.json();

  return {
    options: responseJSON.Search || [],
    hasMore: Math.ceil(responseJSON.totalResults / 10) > page,
    additional: {
      page: searchQuery ? 1 : page + 1,
    },
  };
};

const CustomMultiValue = (props) => (
  <components.MultiValue {...props}>
    <div className="searchable-dropdown-selected-parent">
      <div className="searchable-dropdown-selected-container">
        <Text variant="smallText" color="primaryColor">
          {props.data.label}
        </Text>
      </div>
      <div
        style={{ marginLeft: "6px", cursor: "pointer" }}
        onClick={() => props.removeProps.onClick()}
      >
        <DeleteIcon className="primary-icon-container" />
      </div>
    </div>
  </components.MultiValue>
);

const ReactSelectPaginate = ({ placeholder }) => {
  const [value, setValue] = useState(null);

  const customStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "10px",
      borderColor: "#ccc",
      minHeight: "44px",
      boxShadow: "none",
      "&:hover": { borderColor: "#888" },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f8f0" : "white",
      color: state.isSelected ? "#2e7d32" : "#333",
      padding: "10px 12px",
    }),
  };

  return (
    <div>
      <AsyncPaginate
        id="companyId"
        loadOptions={loadOptions}
        value={value}
        getOptionValue={(option) => option.imdbID}
        getOptionLabel={(option) => option.Title}
        onChange={setValue}
        additional={{
          page: 1,
        }}
        isSearchable={true}
        placeholder={placeholder}
        debounceTimeout={500}
        isMulti
        // components={{ MultiValue: CustomMultiValue }}
        // customStyles={customStyles}
        styles={{
          placeholder: (base) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
            fontSize: "14px",
            color: colors["lightText"],
          }),
          input: (base) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
          }),
          option: (base, state) => ({
            ...base,
            fontFamily: "Figtree, sans-serif",
            fontSize: "14px",
            color: state.isFocused ? colors["white"] : colors["darkText"],
            backgroundColor: state.isFocused
              ? colors["primaryColor"]
              : colors["white"],
            borderRadius: "4px",
            paddingTop: "8px",
            paddingBottom: "8px",
            cursor: "pointer",
          }),
        }}
      />
    </div>
  );
};

export default ReactSelectPaginate;
